import React, {useCallback} from "react";
import { ButtonProps, ButtonBase, Button, Card, CardContent } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {PortTheme} from "~/ui/theme";


export type CardButtonProps = Omit<ButtonProps, "variant" | "color"> & {

}


const useStyles = makeStyles<PortTheme, CardButtonProps>(theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        padding: props => ({large: 18, medium: 16, small: 14}[props.size]),
        fontWeight: 600,
        color: theme.palette.text.primary,
        "&:hover,&:active": {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.paper
        }
    },
    label: {
        width: "100%",
        textAlign: "left"
    }
}));


export const CardButton = (props: CardButtonProps) => {
    const {className, children, ...otherProps} = props;
    const classes = useStyles(props);
    return (
        <Button {...otherProps} className={[classes.root, className].filter(Boolean).join(" ")} focusRipple={false}>
            <span className={classes.label}>{children}</span>
        </Button>
    )
}